/* eslint no-use-before-define: 0 */ // --> OFF
<!--<span class="badge tasks-badge" v-if="activeTasksCounter !== 0">{{-->
<!--          activeTasksCounter-->
<!--        }}</span>-->
<template>
  <div>
    <div class="w100">
      <div class="styleCard">
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs ">
            <!-- v-click-outside="outGroupClose">-->
            <li class="pull-right non-nav">
              <div class="listViewActions paginationContainer">
                <div class="btn-group dropup pull-right">
                  <button
                    @click="setPage(pagination.currentPage - 1)"
                    class="btn btn-sm s-btn-sm"
                    :disabled="pagination.currentPage === 1"
                  >
                    <i
                      :class="
                        pagination.currentPage === 1
                          ? 'fa-chevron-left'
                          : 'fa-chevron-left-black'
                      "
                      class="fa fa-chevron-left"
                    ></i>
                  </button>
                  <button
                    type="button"
                    data-toggle="dropdown"
                    class="btn btn-sm s-btn-sm page-btn "
                    aria-expanded="false"
                  >
                    {{ kFormatter(pagination.currentPage) }}
                    <!--<i class="fa fa-ellipsis-h icon" title="Page Jump"></i>-->
                  </button>
                  <ul class="dropdown-menu p-xy-8 ">
                    <li>
                      <div class="listview-pagenum m-xy-0 p-x-8 m-b-4">
                        <span>Page {{ pagination.currentPage }}</span
                        >&nbsp; &nbsp; <span>of</span>&nbsp;
                        <strong
                          ><span id="totalPageCount">{{
                            pagination.lastPage
                          }}</span></strong
                        >
                      </div>
                      <div class="text-center">
                        <input
                          v-model="pageNumInput"
                          type="text"
                          placeholder="Jump To"
                          class="listViewPagingInput text-center p-xy-0"
                        />&nbsp;
                        <button
                          type="button"
                          id="pageToJumpSubmit"
                          class="listViewPagingInputSubmit"
                          @click="setPage(pageNumInput)"
                          :disabled="pageNumInput > pagination.lastPage"
                        >
                          GO
                        </button>
                        <!--                      <button
                                                    type="button"
                                                    id="pageToJumpSubmit"
                                                    class="listViewPagingInputSubmit"
                                                    @click="setPage(pageNumInput)"
                                                    :disabled="pageNumInput > pagination.lastPage"
                                            >
                                              GO
                                            </button>-->
                      </div>
                    </li>
                  </ul>
                  <button
                    @click="setPage(pagination.currentPage + 1)"
                    class="btn btn-sm s-btn-sm"
                    :disabled="pagination.currentPage === pagination.lastPage"
                  >
                    <i
                      :class="
                        pagination.currentPage > 0 &&
                        pagination.currentPage !== pagination.lastPage
                          ? 'fa-chevron-right-black'
                          : 'fa-chevron-right'
                      "
                      class="fa fa-chevron-right"
                    ></i>
                  </button>
                </div>
                <span
                  class="pageNumbers  pull-right"
                  style="position:relative;"
                >
                  <span class="pageNumbersText">
                    {{ pagination.from }} to {{ pagination.to }}
                  </span>
                  <span
                    class="totalNumberOfRecords cursorPointer"
                    title="Click for this list size"
                    >of {{ pagination.total }}</span
                  >
                  <!--                <i class="fa fa-question showTotalCountIcon"></i>-->
                </span>
              </div>
            </li>
            <li class="pull-left mng-btn-bar-left">
              <!--   &lt;!&ndash; v-if="isAdmin && selectedClients.length > 0"&ndash;&gt;-->

              <button
                v-if="viewResetBtn"
                @click="resetThFields"
                class=" btn btn-trash"
                href="javascript:void(0);"
                title="Reset"
              >
                <i class="fas fa-sync"></i>
              </button>
            </li>
            <li
              class="pull-left"
              v-for="tab in tabs"
              :key="tab.id"
              :class="{ active: selectedTab === tab.alias }"
            >
              <a
                v-if="tab.id === 0"
                href="javascript:void(0)"
                @click="selectedTab = tab.alias"
              >
                {{ tab.name }}
                <span>{{ activeTasksCounter }}</span>
              </a>
              <a
                v-if="tab.id === 1"
                href="javascript:void(0)"
                @click="selectedTab = tab.alias"
              >
                {{ tab.name }}
                <span>{{ stats.waiting_group }} </span>
              </a>
              <!--            <a-->
              <!--              v-if="tab.id === 2"-->
              <!--              href="javascript:void(0)"-->
              <!--              @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->

              <!--              <span>{{ stats.meetings_group }} </span>-->
              <!--            </a>-->
              <!--            <a-->
              <!--              v-if="tab.id === 3"-->
              <!--              href="javascript:void(0)"-->
              <!--              @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->

              <!--              <span>{{ stats.comp_meetings_group }} </span>-->
              <!--            </a>-->
              <!--            <a-->
              <!--              v-if="tab.id === 4"-->
              <!--              href="javascript:void(0)"-->
              <!--              @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->

              <!--              <span>{{ stats.announcements_group }} </span>-->
              <!--            </a>-->
              <!--            <a-->
              <!--              v-if="tab.id === 5"-->
              <!--              href="javascript:void(0)"-->
              <!--              @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->

              <!--              <span>{{ stats.shift_group }} </span>-->
              <!--            </a>-->
              <!--              <a-->
              <!--                v-if="tab.id === 6"-->
              <!--                href="javascript:void(0)"-->
              <!--                @click="selectedTab = tab.alias"-->
              <!--              >-->
              <!--                {{ tab.name }}-->

              <!--                <span>{{ stats.canceled_group }}</span>-->
              <!--              </a>-->
              <a
                v-if="tab.id === 7"
                href="javascript:void(0)"
                @click="selectedTab = tab.alias"
              >
                {{ tab.name }}

                <span> {{ stats.completed_group }} </span>
              </a>
              <!--            <a-->
              <!--                    v-if="tab.id === 10"-->
              <!--                    href="javascript:void(0)"-->
              <!--                    @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->
              <!--              <span>{{ stats.future_group }}</span>-->
              <!--            </a>-->
              <!--              <a-->
              <!--                v-if="tab.id === 11"-->
              <!--                href="javascript:void(0)"-->
              <!--                @click="selectedTab = tab.alias"-->
              <!--              >-->
              <!--                {{ tab.name }}-->
              <!--                <span>{{ stats.waiting_approval_group }}</span>-->
              <!--              </a>-->
              <!--            <a-->
              <!--                    v-if="tab.id === 12"-->
              <!--                    href="javascript:void(0)"-->
              <!--                    @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->
              <!--              <span>{{ stats.sent_group }}</span>-->
              <!--            </a>-->
              <!--            <a-->
              <!--                    v-if="tab.id === 13"-->
              <!--                    href="javascript:void(0)"-->
              <!--                    @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->
              <!--              <span>{{ stats.junk_group }}</span>-->
              <!--            </a>-->
              <a
                  v-if="tab.id === 10"
                  href="javascript:void(0)"
                  @click="selectedTab = tab.alias"
              >
                {{ tab.name }}
                <span>{{ stats.outline_group }}</span>
                <span
                    class="badge counter-not-read-badge"
                    v-if="tab.alias == 'outline' && stats.new.outline_group !== 0"
                >+{{ stats.new.outline_group }}</span
                >
              </a>

              <a
                  v-if="tab.id === 12 && (auth.user.role === 1 || auth.user.role === 2)"
                  href="javascript:void(0)"
                  @click="selectedTab = tab.alias"
              >
                {{ tab.name }}
                <span>{{ stats.events_group }}</span>
              </a>

              <!--              <a-->
              <!--                    v-if="tab.id === 15"-->
              <!--                    href="javascript:void(0)"-->
              <!--                    @click="selectedTab = tab.alias"-->
              <!--            >-->
              <!--              {{ tab.name }}-->
              <!--              <span>{{ stats.replied_email_group }}</span>-->
              <!--            </a>-->
            </li>
            <!--            <li-->
            <!--                    class="pull-right progress-task-timer">-->

            <!--              <TaskClock-->
            <!--                      :mode="'standBy'"-->
            <!--              ></TaskClock>-->
            <!--             -->
            <!--            </li>-->
            <li class="center-msg">
              <div class="dropdown" v-if="false">
                <div class="center-filter-selected">
                  <span>Selected: {{ selectedClientsFrom }}</span>
                  <div v-for="(filter, idx) in filtersBarArr" :key="idx">
                    <filters-bar
                      :filter-text="filter.text"
                      :filter-key="filter.key"
                      :filter-stat="filter.stat"
                      @delete="removeFromFiltersList(filter.key)"
                    ></filters-bar>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active">
              <table class="table main-table">
                <thead>
                  <tr class="tr-info">
                    <th class="th-checkbox">
                      <div>
                        <!--                        <input-->
                        <!--                                v-if="checkPermissions(auth, [1, 2, 3, 4, 5, 12])"-->
                        <!--                                :title="'Select All Clients'"-->
                        <!--                                @click="selectAll"-->
                        <!--                                v-model="bulkCheckBoxChecked"-->
                        <!--                                type="checkbox"-->
                        <!--                        />-->
                        <input
                          :title="'Select All Clients'"
                          @click="selectAll"
                          type="checkbox"
                        />
                      </div>
                    </th>
                    <th class="th-invite">
                      <div class="floating-wrapper">
                        <task-invite-users-multi-select
                          v-model="filters.task_invite_users"
                          :options="salesPersonList"
                          :reset-list="resetMultiSelects"
                          @reset="resetInviteUsersSelector"
                          :other-filtering="true"
                          :initiated-filtering="resetMsAfterFilter"
                          :query-object="getQueryParamsToMs"
                        ></task-invite-users-multi-select>
                      </div>
                    </th>
                    <th class="th-id">
                      <div class="th-id-div">
                        <input
                          class="input-id"
                          placeholder="ID"
                          v-model="filters.task_id"
                        />
                        <button
                          @click="applyAmountSorting"
                          class="sort-btn-th sort-in-btn"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-amount-down':
                                filters.sort_for_id === 'ASC' ||
                                filters.sort_for_id == null,
                              'fas fa-sort-amount-up':
                                filters.sort_for_id === 'DESC'
                            }"
                          ></span>
                        </button>
                      </div>
                    </th>
                    <th class="th-type-small">
                      <div class="floating-wrapper">
                        <task-type-multi-select
                          :options="taskDictionaries.general.task_types"
                          v-model="filters.task_types"
                          :reset-list="resetMultiSelects"
                          @reset="resetTaskTypeSelector"
                          :initiated-filtering="resetMsAfterFilter"
                          :query-object="getQueryParamsToMs"
                        >
                          >
                        </task-type-multi-select>
                      </div>
                    </th>
                    <th class="th-type">
                      <div
                        class="floating-wrapper"
                        v-click-outside="taskStatusOutClose"
                      >
                        <task-status-filter-btn
                          @regular="statusFilterMenuHandler"
                          :disabled="filters.task_sub_statuses.length > 0"
                          :disabled-comming="filters.coming_tasks"
                          :disabled-missed="filters.missed_tasks"
                          :disabled-today="filters.today_tasks"
                          :bg-color="statusBtnColors.bgCall"
                          :txt-color="statusBtnColors.txtWhite"
                          :text="'STATUS'"
                          :stats="stats.scheduled_calls"
                          :right-ear="stats.tasks_missed"
                          :left-ear="stats.tasks_coming"
                          :today-ear="stats.tasks_today"
                          @missed="missedTasksFilterMenuHandler"
                          @coming="comingTasksFilterMenuHandler"
                          @today="todayTasksFilterMenuHandler"
                        ></task-status-filter-btn>

                        <task-status-multi-select
                          :options="
                            taskDictionaries.general.task_sub_status_types
                          "
                          v-model="filters.task_sub_statuses"
                          :reset-list="resetMultiSelects"
                          @reset="resetTaskStatusesSelector"
                          :open-task-menu="openTaskStatusMenu"
                          @close="openTaskStatusMenu = false"
                          :initiated-filtering="resetMsAfterFilter"
                          :query-object="getQueryParamsToMs"
                        ></task-status-multi-select>
                      </div>
                    </th>
                    <th class="th-task-content">
                      <div class="div-flex-wrapper">
                        <div class="tags-search">
                          <!--                        @changeTitle="updateTitle"-->
                          <tags-multi-select
                            :resetClicked="resetClicked"
                            v-model="filters.tag_title"
                            :reset-list="resetMultiSelects"
                            @reset="resetUsersSelector"
                            @updateTags="filterTagTitle"
                            :other-filtering="true"
                            :initiated-filtering="resetMsAfterFilter"
                            :query-object="getQueryParamsToMs"
                          ></tags-multi-select>
                        </div>
                        <div class="search-input-wrapper">
                          <input
                            type="search"
                            class="form-control"
                            placeholder="Type a word"
                            id="word-search"
                            v-model="wordFilter"
                          />
                        </div>
                        <div class="open-btns-wrapper">
                          <button
                            class="btn btn-success dropdown-toggle align-it"
                            type="button"
                            @click="toggleMainTaskWindow()"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                          <span v-if="CheckUserPermission([1, 2])">
                            <label class="multi-check-label" for="check-dup">
                              <input
                                type="checkbox"
                                class="multi-check"
                                v-model="filters.show_all_tasks"
                                id="check-dup"
                              />
                              SHOW ALL
                            </label></span
                          >
                        </div>
                      </div>
                    </th>
                    <!--                    TODO create a component for filter by files-->
                    <th class="images-sort">
                      <div class="show-image-all">
                        <label for="show-img-view">SHOW IMAGES</label>
                        <input id="show-img-view" type="checkbox" @click="showCards = !showCards">
                      </div>
<!--                      <select name="" id="">-->
<!--                        <option value="0">...</option>-->
<!--                        <option value="IMG">IMG</option>-->
<!--                        <option value="DOC">DOC</option>-->
<!--                        <option value="EXL">EXL</option>-->
<!--                        <option value="PDF">PDF</option>-->
<!--                      </select>-->
                    </th>
                    <th class="th-timer">
                      <!--                      EST<br />-->
                      <span v-if="totalEst === 0 || totalEst === ''">{{
                        "0 hours"
                      }}</span>
                      <span v-if="totalEst !== 0 && totalEst !== ''">{{
                        totalEst
                      }}</span>
                    </th>
                    <th class="th-date-created">
                      <div><span>START</span></div>
                    </th>
                    <!--                    <th class="th-timer" v-if="selectedTab !== 'completed'">-->
                    <!--                      &lt;!&ndash;                      <img class="timer-icon" src="img/icons/watch.svg" />&ndash;&gt;-->
                    <!--                      SPT-->
                    <!--                      <button-->
                    <!--                        @click="applyAmountSortingSpt"-->
                    <!--                        class="sort-btn-th"-->
                    <!--                      >-->
                    <!--                        <span-->
                    <!--                          class="fa"-->
                    <!--                          :class="{-->
                    <!--                            'fas fa-sort-amount-down':-->
                    <!--                              filters.sort_for_spt === 'ASC' ||-->
                    <!--                              filters.sort_for_spt == null,-->
                    <!--                            'fas fa-sort-amount-up':-->
                    <!--                              filters.sort_for_spt === 'DESC'-->
                    <!--                          }"-->
                    <!--                        ></span>-->
                    <!--                      </button>-->

                    <!--                      <br /><span v-if="totalSpt !== 0 && totalSpt !== ''"-->
                    <!--                        >{{ totalSpt }}-->
                    <!--                        <button-->
                    <!--                          @click="applyAmountSortingTimeRunning"-->
                    <!--                          :class="{-->
                    <!--                              'running-btn-off':-->
                    <!--                                filters.sort_for_time_running === false ||-->
                    <!--                                filters.sort_for_time_running == null,-->
                    <!--                              'running-btn-on':-->
                    <!--                                filters.sort_for_time_running === true-->
                    <!--                            }"-->
                    <!--                        >-->

                    <!--                        </button>-->
                    <!--                      </span>-->
                    <!--                    </th>-->
                    <th class="th-timer" v-if="selectedTab !== 'completed'">
                      <!--                      <img class="timer-icon" src="img/icons/watch.svg" />-->
                      <button
                        @click="applyAmountSortingTimeRunning"
                        class="btn btn-block"
                        :class="{
                          'running-btn-off':
                            filters.sort_for_time_running === false ||
                            filters.sort_for_time_running == null,
                          'running-btn-on':
                            filters.sort_for_time_running === true
                        }"
                      >
                        <span
                          v-if="totalSpt !== 0 && totalSpt !== ''"
                          class="total-spt-title"
                          >{{ totalSpt }}
                        </span>
                      </button>
                      <p
                        class="table-running-indicator"
                        @click="applyAmountSortingTaskOnWork('not_work')"
                      ></p>
                      <p
                        class="table-running-indicator-active"
                        @click="applyAmountSortingTaskOnWork('work')"
                      ></p>
                    </th>
                    <th class="th-total text-center">TOT</th>
                    <th class="th-invite-date">
                      <div><span>END</span></div>
                    </th>
                    <th class="th-date-mod">
                      <div class="th-mod-div">
                        <span class="th-mod-title">CREATED</span>
                        <button
                          @click="applyAmountSortingCreated"
                          class="sort-btn-th"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-amount-down':
                                filters.sort_for_created === 'ASC' ||
                                filters.sort_for_created == null,
                              'fas fa-sort-amount-up':
                                filters.sort_for_created === 'DESC'
                            }"
                          ></span>
                        </button>
                      </div>
                    </th>
                    <th class="th-date-mod">
                      <div class="th-mod-div">
                        <span class="th-mod-title">MODIFIED</span>
                        <button
                          @click="applyAmountSortingMod"
                          class="sort-btn-th"
                        >
                          <span
                            class="fa"
                            :class="{
                              'fas fa-sort-amount-down':
                                filters.sort_for_mod === 'ASC' ||
                                filters.sort_for_mod == null,
                              'fas fa-sort-amount-up':
                                filters.sort_for_mod === 'DESC'
                            }"
                          ></span>
                        </button>
                      </div>
                    </th>

                    <th class="th-created-by">
                      <!--                      <div-->
                      <!--                        :class="-->
                      <!--                          filters.show_all_tasks != false-->
                      <!--                            ? 'floating-wrapper'-->
                      <!--                            : 'floating-wrapper-disabled'-->
                      <!--                        "-->
                      <!--                      >-->
                      <div
                        class="floating-wrapper
                        "
                      >
                        <task-users-multi-select
                          v-model="filters.task_users"
                          :options="salesPersonList"
                          :reset-list="resetMultiSelects"
                          @reset="resetUsersSelector"
                          :other-filtering="true"
                          :initiated-filtering="resetMsAfterFilter"
                          :query-object="getQueryParamsToMs"
                        ></task-users-multi-select>
                      </div>
                    </th>

                    <!--                    <th class="th-priority">-->
                    <!--                      <div class="floating-wrapper">-->
                    <!--                        <priority-multi-select-->
                    <!--                          :options="-->
                    <!--                            taskDictionaries.general.task_priority_types-->
                    <!--                          "-->
                    <!--                          v-model="filters.task_priorities"-->
                    <!--                          :reset-list="resetMultiSelects"-->
                    <!--                          @reset="resetPrioritySelector"-->
                    <!--                          :initiated-filtering="resetMsAfterFilter"-->
                    <!--                          :query-object="getQueryParamsToMs"-->
                    <!--                        ></priority-multi-select>-->
                    <!--                      </div>-->
                    <!--                    </th>-->

                    <th class="th-log">
                      <div>
                        <!--<input class="input-standard" placeholder="Log" />-->
                      </div>
                    </th>

                    <!--@fetchstats="fetchCountryMultiSelectStats"-->
                  </tr>
                </thead>
                <tbody v-if="!showCards">
                  <tr
                    v-for="(task, idx) in tasks"
                    :key="task.id"
                    :class="{
                      danger:
                        task.id !== highlightedClientId &&
                        task.id !== highlightedHoverClientId &&
                        task.missedScheduledCall,
                      warning:
                        task.id !== highlightedClientId &&
                        task.id !== highlightedHoverClientId &&
                        task.scheduledCallSoon,
                      'selected-client': task.id === highlightedClientId,
                      'selected-client-hover':
                        task.id === highlightedHoverClientId,
                      readOnly: giveReadOnlyTaskBackgroundGrey(task)
                    }"
                    @click="highlightedClientId = task.id"
                    @mouseenter="highlightedHoverClientId = task.id"
                    @mouseleave="highlightedHoverClientId = null"
                  >
                    <td class="td-center task-item-td">
                      <template>
                        <div>
                          <!--                          <input-->
                          <!--                                  v-if="checkPermissions(auth, [1, 2, 3, 4, 5, 12])"-->
                          <!--                                  type="checkbox"-->
                          <!--                                  v-model="selectedTasks"-->
                          <!--                                  :value="task.id"-->
                          <!--                          />-->
                          <!--                        </div>-->
                          <input
                            type="checkbox"
                            v-model="selectedTasks"
                            :value="task.id"
                          />
                        </div>
                      </template>
                    </td>
                    <td class="td-center task-item-td">
                      <task-to-user
                        :task="task"
                        :selectedTab="selectedTab"
                        :showAll="filters.show_all_tasks"

                      ></task-to-user>
                    </td>
                    <td
                        v-tooltip.top="{
                         content: 'Copied!',
                         show: copiedTaskId===task.id,
                         autoHide: false,
                         trigger: 'manual'
                         }"
                        style="cursor: pointer;white-space: nowrap;border: none"
                        :id="'task'+task.id"
                        @click="copyStringToClipboard('#'+task.id, task.id)"
                        class="td-center task-item-td btn copy-button"
                    >#{{ task.id }}
                      <i class="fas fa-copy"></i>
                    </td>
                    <td class="td-center task-item-td">
                      <task-type
                        :task="task"
                        :selectedTab="selectedTab"
                      ></task-type>
                    </td>
                    <td class="td-center task-item-td">
                      <div>
                        <task-status-type
                          :task="task"
                          :selectedTab="selectedTab"
                          @updated="fetchTasks()"
                        ></task-status-type>
                      </div>
                    </td>
                    <td class="td-center task-item-td td-task-content">
                      <div class="floating-wrapper">
                        <task-content
                            :taskOpenedFromImg="taskOpenedFromImg"
                          v-if="taskToUpdateId === null"
                          :task="task"
                          :wordFilter="wordFilter"
                          :preOpenTaskFromChart="
                            tasks.length == 1 ? preOpenTaskFromChart : false
                          "
                          :preOpenMeetingFromMsgCenter="
                            tasks.length == 1
                              ? preOpenMeetingFromMsgCenter
                              : false
                          "
                          :isClicked="filters.show_all_tasks"
                          @tagsFillter="tagsFillter"
                          @updated="fetchTasks"
                          @show_assign_inp="handleReplyPrepare"
                          @clear_sets="clearReplySets"
                          :assign-reply-to="assignReplyTo"
                          :reply-status="replyStatus"
                          :selectedMainTab="selectedTab"
                          :query-object="getQueryParamsToMs"
                          @changeToWaitingTabAfterCreatingATask="
                            changeToWaitingTabAfterCreatingATask
                          "
                        ></task-content>
                      </div>
                    </td>
                    <td class="images-td">
                      <TaskAttachmentTd :task="task" />
                    </td>
                    <td
                      class="td-center task-item-td task-item-td-time-quantity"
                    >
                      <task-time-quantity
                        @updated="fetchTasks"
                        :task="task"
                        :idx="idx"
                      ></task-time-quantity>
                    </td>

                    <td
                      class="td-center task-item-td task-item-td-time"
                      style="white-space: nowrap"
                    >
                      {{ formatDate(task.start_time) }}
                    </td>
                    <td
                      class="td-center task-item-td task-item-td-time"
                      v-if="selectedTab !== 'completed'"
                    >
                      <TaskClock
                        :task_id="task.id"
                        :task="task"
                        :class="task.id"
                        :user_id="task.user_id"
                        :times_arr="task.task_time_duration"
                        @updated="fetchTasks"
                        :selectedMainTab="selectedTab"
                        :mode="'standBy'"
                        :showAll="filters.show_all_tasks"
                      ></TaskClock>
                    </td>
                    <td class="td-center task-item-td task-item-td-time">
                      {{ getTaskTotalTime(task.task_time_duration) }}
                    </td>
                    <td class="td-center task-item-td task-item-td-time">
                      <task-completed-date
                        @updated="fetchTasks()"
                        :task="task"
                      ></task-completed-date>
                    </td>
                    <td class="td-center task-item-td task-item-td-time">
                      {{ formatDate(task.created_at) }}
                    </td>
                    <td class="td-center task-item-td task-item-td-time">
                      {{ formatDate(task.updated_at) }}
                    </td>
                    <td class="td-center task-item-td">
                      <task-from-user :task="task"></task-from-user>


                    </td>
                    <!--                    <td class="td-center">-->
                    <!--                      &lt;!&ndash;   <task-priority :task="task"></task-priority>&ndash;&gt;-->

                    <!--                      <div class="dropdown">-->
                    <!--                        <span class="pointer" data-toggle="dropdown">-->
                    <!--                          <task-priority :task="task"></task-priority>-->
                    <!--                        </span>-->
                    <!--                        <ul-->
                    <!--                          class="p-xy-8 dropdown-menu assignment-dropdown-menu"-->
                    <!--                        >-->
                    <!--                          <div class="add-tag-menu-item-title">-->
                    <!--                            Update Priority-->
                    <!--                          </div>-->

                    <!--                          <li-->
                    <!--                            class="assign-menu-item"-->
                    <!--                            v-for="type in taskDictionaries.general-->
                    <!--                              .task_priority_types"-->
                    <!--                            :key="type.id"-->
                    <!--                            @click="updatePriority(type.id, task.id)"-->
                    <!--                          >-->
                    <!--                            {{ type.title }}-->
                    <!--                          </li>-->
                    <!--                        </ul>-->
                    <!--                      </div>-->
                    <!--                    </td>-->

                    <td class="td-center task-item-td">
                      <task-log :task="task"></task-log>
                      <div class="task-menu"></div>
                    </td>
                  </tr>
                  <tr>
                    <div v-show="tasks.length < 2" class="cartoon">
                      <img src="/img/cartoon/homer-eat.jpg" />
                    </div>
                  </tr>
                </tbody>
                <tbody v-if="showCards && cardDisplayRows">
                  <tr class="image-show-row">
                    <td v-if="idx <= 6" v-for="(task, idx) in tasksCards" :key="task.id" >
                    <TaskCardsView
                        :rowPosition="true"
                        :task="task"
                        :twoRows="cardDisplayRows"
                        @showTask="openTaskFromImg"
                        :taskOpenedFromImg="null"
                        v-if="taskToUpdateId === null"
                        :wordFilter="wordFilter"
                        :preOpenTaskFromChart="
                        tasks.length == 1 ? preOpenTaskFromChart : false"
                        :preOpenMeetingFromMsgCenter="
                        tasks.length == 1
                              ? preOpenMeetingFromMsgCenter
                              : false"
                        :isClicked="filters.show_all_tasks"
                        @tagsFillter="tagsFillter"
                        @updated="fetchTasks"
                        @show_assign_inp="handleReplyPrepare"
                        @clear_sets="clearReplySets"
                        :assign-reply-to="assignReplyTo"
                        :reply-status="replyStatus"
                        :selectedMainTab="selectedTab"
                        :query-object="getQueryParamsToMs"
                        @changeToWaitingTabAfterCreatingATask="changeToWaitingTabAfterCreatingATask"
                    />
                  </td>
                  </tr>
                  <tr class="image-show-row-1">
                  <td v-if="idx > 6" v-for="(task, idx) in tasksCards" :key="task.id" >
                    <TaskCardsView
                        :rowPosition="false"
                        :task="task"
                        :twoRows="cardDisplayRows"
                        @showTask="openTaskFromImg"
                        :taskOpenedFromImg="null"
                        v-if="taskToUpdateId === null"
                        :wordFilter="wordFilter"
                        :preOpenTaskFromChart="
                        tasks.length == 1 ? preOpenTaskFromChart : false"
                        :preOpenMeetingFromMsgCenter="
                        tasks.length == 1
                              ? preOpenMeetingFromMsgCenter
                              : false"
                        :isClicked="filters.show_all_tasks"
                        @tagsFillter="tagsFillter"
                        @updated="fetchTasks"
                        @show_assign_inp="handleReplyPrepare"
                        @clear_sets="clearReplySets"
                        :assign-reply-to="assignReplyTo"
                        :reply-status="replyStatus"
                        :selectedMainTab="selectedTab"
                        :query-object="getQueryParamsToMs"
                        @changeToWaitingTabAfterCreatingATask="changeToWaitingTabAfterCreatingATask"
                    />
                  </td>
                </tr>
                </tbody>
                <tbody v-if="showCards && cardDisplayRows === false">
                  <tr class="image-show-one-row">
                  <td v-if="idx <= 6" v-for="(task, idx) in tasksCards" :key="task.id" >
                    <TaskCardsView
                        :rowPosition="true"
                        :task="task"
                        :twoRows="cardDisplayRows"
                        @showTask="openTaskFromImg"
                        :taskOpenedFromImg="null"
                        v-if="taskToUpdateId === null"
                        :wordFilter="wordFilter"
                        :preOpenTaskFromChart="
                        tasks.length == 1 ? preOpenTaskFromChart : false"
                        :preOpenMeetingFromMsgCenter="
                        tasks.length == 1
                              ? preOpenMeetingFromMsgCenter
                              : false"
                        :isClicked="filters.show_all_tasks"
                        @tagsFillter="tagsFillter"
                        @updated="fetchTasks"
                        @show_assign_inp="handleReplyPrepare"
                        @clear_sets="clearReplySets"
                        :assign-reply-to="assignReplyTo"
                        :reply-status="replyStatus"
                        :selectedMainTab="selectedTab"
                        :query-object="getQueryParamsToMs"
                        @changeToWaitingTabAfterCreatingATask="changeToWaitingTabAfterCreatingATask"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <MainTaskWindow
          :key="closeRec"
          @close="countClose()"
          v-if="showMainTaskWindow"
          @changeToWaitingTabAfterCreatingATask="
            changeToWaitingTabAfterCreatingATask
          "
          :preOpenMainTaskWindowFromHeader="preOpenMainTaskWindowFromHeader"
          v-click-outside="closeMainTaskWindow"
          v-on:fetchTasks="fetchTasks"
          v-on:closeMainTaskWindow="closeMainTaskWindow"
          :selectedTaskTab="selectedTab"
          @updated="fetchTasks"
          mode="add"
        />
      </transition>
      <!--      v-on:setTaskTransfer="setTaskTransfer"-->
    </div>
    <TasksRightCornerImagesBox
        :tasks="tasks"
    />

<!--    <TasksMainCalendar-->
<!--      :tabs="tabs"-->
<!--      :stats="stats"-->
<!--      :query-object="queryObject"-->
<!--       @due_date="setDueDate"-->
<!--       @invoice_date="setInvoiceDate"-->
<!--       @purchase_date="setDate"-->
<!--       @resetOneCalendar="clearDates"-->
<!--       @total_spent_by_date="setTotalSpentDate"-->
<!--       @payment_method_info="setPaymentMethodsInfo"-->
<!--    />-->

    <TasksMainCalendar
            :tabs="tabs"
            :stats="stats"
            :query-object="queryObject"
    />
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment/moment";
import TaskModel from "../components/TaskModel";
import UsersActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import { mapState, mapGetters, mapActions } from "vuex";
import apiClientCreator from "../../../helpers/api/request";
import TaskStatusType from "../components/TaskStatusType";
import TaskType from "../components/TaskType";
import TaskFromUser from "../components/TaskFromUser";
import TaskToUser from "../components/TaskToUser";
import TaskContent from "../components/TaskContent";
import TaskLog from "../components/TaskLog";
import TaskCompletedDate from "../components/TaskCompletedDate";
import TaskTypeMultiSelect from "../components/multiselects/TaskTypeMultiSelect.component";
import TaskStatusMultiSelect from "../components/multiselects/TaskStatusMultiSelect.component";
import TaskUsersMultiSelect from "../components/multiselects/UserMultiSelect.component";
import TagsMultiSelect from "../components/multiselects/TagsMultiSelect.component";
import TaskInviteUsersMultiSelect from "../components/multiselects/InviteUserMultiSelect.component";
import FiltersBar from "../../company.feature/sub_features.company/clients_table.sub_feature.company/components/FiltersBar";
import MainTaskWindow from "../components/MainTaskWindow.component";
import TaskStatusFilterBtn from "../components/filter_buttons/TaskStatusFilterButton.component";
import TaskTimeQuantity from "../components/TaskTimeQuantity";
import vClickOutside from "v-click-outside";
import TaskClock from "../components/TaskClock.component";
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";
import hoursFormatterUtil from "../../../mixins/system/hoursFormatterUtil";
import TaskAttachmentTd from "../components/TaskAttachmentTd";
import TasksRightCornerImagesBox from "../components/TasksRightCornerImagesBox";
import TaskCardsView from "../components/TaskCardsView.component";
import TasksMainCalendar from "../components/TasksMainCalendar";

export default {
  name: "TasksTable.container",
  mixins: [UsersActiveScope, UsersPermissionCheck, hoursFormatterUtil],
  components: {
    TasksMainCalendar,
    TaskClock,
    TaskFromUser,
    TaskStatusType,
    TaskType,
    TaskToUser,
    TaskContent,
    TaskLog,
    TaskCompletedDate,
    TaskTypeMultiSelect,
    TaskStatusMultiSelect,
    TaskUsersMultiSelect,
    TaskInviteUsersMultiSelect,
    FiltersBar,
    TaskStatusFilterBtn,
    TaskTimeQuantity,
    MainTaskWindow,
    TagsMultiSelect,
    TaskAttachmentTd,
    TasksRightCornerImagesBox,
    TaskCardsView
  },
  directives: {
    clickOutside: vClickOutside.directive
  },

  data() {
    return {
      tasksCards: [],
      cardDisplayRows: false,
      copiedTaskId:-1,
      taskOpenedFromImg: null,
      showCards: false,
      queryObject: {
        page: 1
      },
      allTasksTotalTime: "00:00:00",
      sortOrderAmount: "asc",
      closeRec: 0,
      stats: {
        events_group:0,
        completed_group: 0,
        tasks_missed: 0,
        tasks_coming: 0,
        tasks_today: 0,
        waiting_group: 0,
        waiting_approval_group: 0,
        outline_group: 0,
        new: {
          outline_group: 0
        }
      },
      statusBtnColors: {
        bgCall: "#fa8100",
        bgNew: "#00c853",
        bgActive: "#008b00",
        bgNA: "#F4511E",
        bgBN: "#000",
        bgNIN: "#424242",
        bgRF: "#d32f2f",
        bgTR: "#827717",
        bgWT: "#00796b",
        bgDP: "#7b1fa2",
        bgLD: "#1144bc",
        bgAll: "#311b92",
        txtGrey: "#212121",
        txtWhite: "#ffffff"
      },
      tabs: [
        {
          id: 0,
          name: "ACTIVE",
          alias: "active"
        },
        {
          id: 1,
          name: "WAITING",
          alias: "waiting"
        },
        {
          id: 7,
          name: "COMPLETED",
          alias: "completed"
        },

        {
          id: 11,
          name: "WAITING APPROVAL",
          alias: "waiting_approval"
        },
        {
          id: 10,
          name: "OUTLINE",
          alias: "outline"
        },
        {
          id:12,
          name:"EVENTS",
          alias: "events"
        }
      ],
      selectedTasks: [],
      flagFilterMeeting: null,
      filters: {
        active_group: true,
        outline_group: false,
        waiting_group: false,
        completed_group: false,
        events_group:false,
        waiting_approval_group: false,
        task_id: null,
        task_types: [],
        task_sub_statuses: [],
        coming_tasks: false,
        missed_tasks: false,
        today_tasks: false,
        task_priorities: [],
        task_invite_users: [],
        task_users: [],
        tag_id: [],
        tag_title: null,
        status_assigned_at: {},
        show_all_tasks: false,
        sort_for_id: null,
        sort_for_mod: null,
        sort_for_created: null,
        sort_for_spt: null,
        sort_for_time_running: null,
        sort_for_task_on_work: null,
        key_word: null
      },
      openTaskStatusMenu: false,
      tasks: [], // kobi
      filtersBarArr: [],
      taskToUpdateId: null,
      pagination: {
        currentPage: 1,
        perPage: 5,
        from: 1,
        to: 1,
        lastPage: 1,
        total: 0
      },

      selectedTab: "active",
      resetCalendars: false,
      resetMultiSelects: false,
      resetDeviceSelector: false,
      resetMsAfterFilter: false,
      getQueryParamsToMs: {},
      sendUpdated: true,
      pageNumInput: "",
      viewResetBtn: false,
      highlightedHoverClientId: null,
      showReplyAssignInp: null,
      showReplyStatusInp: null,
      assignReplyTo: [],
      startAssignReplyTo: [],
      isShowTaskTypes: false,
      isShowTaskSubTypes: false,
      showMainTaskWindow: false,

      replyStatus: {
        id: 1,
        type: "REPLY",
        title: "Replied",
        op: "Reply"
      },
      resetClicked: false,
      temp: "",
      totalEst: "",
      totalSpt: "",
      wordFilter: ""
    };
  },
  ...mapState("user", ["auth"]),
  ...mapGetters("user", ["isLogged"]),
  computed: {
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading",
       "searchByTaskId"

    ]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapGetters("clients", ["getSearchByTaskId"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("globalSearch",['currentAction']),
    ...mapState("tasks", [
      "tasks",
      "activeTasks",
      "allActiveTasks",
      "getFetchTasks",
      "activeTasksCounter",
      "chartDataToTable", // Lev - is it from vueX?
      "taskDictionaries",
      "preOpenTaskFromChart",
      "tasksFilteringVuexObj",
      "preOpenMeetingFromMsgCenter",
      "preOpenMainTaskWindowFromHeader",
      "openRepForEmails"
    ]),
    ...mapGetters("tasks", [
      "getTasks",
      "getActiveTasks",
      "getAllActiveTasks",
      "getActiveTasksCounter"
    ])
  },
  created() {
    this.checkSavedTaskInStorage();
    // this.$store.dispatch("tasks/fetchAllActiveTasks");
  },
  watch: {
    openRepForEmails:function(){
      this.toggleMainTaskWindow();
    },
    currentAction:function(){
      switch (this.currentAction) {
        case "open-new-task":
          this.globalOpenNewTask()
          break;
        case "open-completed-task":
          this.globalChangeTab("completed")
          break;
          case "open-waiting-task":
          this.globalChangeTab("waiting")
          break;
          case "open-active-task":
          this.globalChangeTab("active")
          break;
      }
    },
    showCards: function(){
      this.fetchTasks();
    },
    wordFilter: function() {
      if (this.wordFilter.length > 3) {
        this.filters.key_word = this.wordFilter;
      } else {
        this.filters.key_word = "";
      }
    },
    preOpenMainTaskWindowFromHeader: function() {
      if (this.preOpenMainTaskWindowFromHeader) {
        this.toggleMainTaskWindow();
      }
      // this.$store.commit("tasks/setPreOpenMainTaskWindowFromHeader", false);
    },
    tasksFilteringVuexObj: function() {
      if (this.tasksFilteringVuexObj.hasOwnProperty("id")) {
        this.selectedTab = "active";
        this.filters.task_id = this.tasksFilteringVuexObj.id;
      }
    },

    chartDataToTable: function() {
      let group;
      if (this.chartDataToTable.hasOwnProperty("groupId")) {
        group = this.chartDataToTable.groupId;
      }

      if (this.chartDataToTable.hasOwnProperty("dates")) {
        let start = this.chartDataToTable.dates.dateRange.start;
        let end = this.chartDataToTable.dates.dateRange.end;
        this.filters.status_assigned_at = [start, end];
        // this.filters.status_assigned_from = start;
        // this.filters.status_assigned_to = end;
      }

      //Lev -
      if (group === "NO_COMP") {
        this.selectedTab = "waiting";
      }
      if (group === "COMP") {
        this.selectedTab = "completed";
      }
      if (group === "ACTIVE") {
        this.selectedTab = "active";
      }
      if (group === "tag") {
        // this.filters.tag_id = this.chartDataToTable.tagId;
        if (this.chartDataToTable.tagId.length > 0) {
          this.filters.tag_id.push(this.chartDataToTable.tagId[0]);
        }
      }

      if (this.chartDataToTable.hasOwnProperty("userId")) {
        let user = this.chartDataToTable.userId;
        //this.resetThFields();
        this.filters.task_invite_users = [{ id: user }];
      }
    },
    getFetchTasks: function() {
      if (this.getFetchTasks.flag) {
        this.fetchTasks();
        this.$store.commit("tasks/setFetchTasks", { flag: false });
        // this.$store.dispatch("tasks/fetchActiveTasks");
      }
    },
    "filters.show_all_tasks": function() {
      this.debouncedTasksQuery();
    },

    selectedTab: function() {
      this.$store.dispatch("tasks/fetchActiveTasks");

      if (this.selectedTab === "active") {
        this.filters.active_group = true;
        this.filters.completed_group = false;
        this.filters.waiting_group = false;
        this.filters.outline_group = false;
        this.filters.events_group = false;
        return this.debouncedTasksQuery();
      }

      if (this.selectedTab === "outline") {
        this.filters.outline_group = true;
        this.filters.completed_group = false;
        this.filters.waiting_group = false;
        this.filters.active_group = false;
        this.filters.events_group = false;
        return this.debouncedTasksQuery();
      }

      if (this.selectedTab === "waiting") {
        this.filters.outline_group = false;
        this.filters.completed_group = false;
        this.filters.active_group = false;
        this.filters.waiting_group = true;
        this.filters.events_group = false;
        return this.debouncedTasksQuery();
      }

      if (this.selectedTab === "completed") {
        this.filters.outline_group = false;
        this.filters.waiting_group = false;
        this.filters.active_group = false;
        this.filters.completed_group = true;
        this.filters.events_group = false;
        return this.debouncedTasksQuery();
      }
      if (this.selectedTab === "events") {
        this.filters.outline_group = false;
        this.filters.waiting_group = false;
        this.filters.active_group = false;
        this.filters.completed_group = false;
        this.filters.events_group = true;
        return this.debouncedTasksQuery();
      }
    },
    tasks: function() {
      if(this.showCards){
        this.tasksCards = this.tasks.filter(task => {
          return (this.getSrc(task.content) != '');
        })

      }
      if (this.auth.user.role === 1 || this.auth.user.role === 2) {
        if (this.filters.show_all_tasks === false) {
          if (this.tasks.length === 0) {
            this.filters.show_all_tasks = true;
          }
        }
      }
    },
    "filters.task_id": function(prev, current) {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },

    "filters.task_types": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.task_statuses": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.task_sub_statuses": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.task_priorities": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.task_invite_users": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.task_users": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.tag_id": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.tag_title": function() {
      this.filters.tag_id = [];
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.status_assigned_at": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.sort_for_id": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.sort_for_mod": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.sort_for_created": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.sort_for_spt": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.sort_for_time_running": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.sort_for_task_on_work": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    },
    "filters.key_word": function() {
      this.debouncedTasksQuery();
      this.viewHideResetBtn();
    }
  },
  mounted() {
    this.filters.task_id = this.getSearchByTaskId;
    this.fetchTasks();
    this.$store.dispatch("tasks/fetchActiveTasks");
    this.$store.dispatch("tasks/getTopFiveTagsFromLast100");
    this.$store.dispatch("tasks/getTopThreeUsersFromLast100");
    this.$store.dispatch("tasks/getCategories");
    if (this.preOpenMainTaskWindowFromHeader) {
      this.toggleMainTaskWindow();
      // this.$store.commit("tasks/setPreOpenMainTaskWindowFromHeader", false);
    }
    // this.$store.commit("tasks/setFetchTasks", { flag: false });
    this.$root.$on("change_tab_to_waiting", data => {
      this.selectedTab = "waiting";
    });


    if(this.currentAction==="open-new-task") this.globalOpenNewTask();
   else if(this.currentAction==="open-active-task") this.globalChangeTab("active");
   else if(this.currentAction==="open-completed-task") this.globalChangeTab("completed");
   else if(this.currentAction==="open-waiting-task") this.globalChangeTab("waiting");


    },

  methods:{
    globalOpenNewTask(){
      this.toggleMainTaskWindow();
      this.$store.commit("globalSearch/setNewGlobalAction","") // resetting the action
    },
    globalChangeTab(tab){
      this.selectedTab=tab

      this.$store.commit("globalSearch/setNewGlobalAction","") // resetting the action
    },
    openTaskFromImg(taskId){
      // this.showCards = !this.showCards;
      this.taskOpenedFromImg = taskId;
      // this.showCards = false;
      document.getElementById('show-img-view').checked = false;
    },

    copyStringToClipboard(str, copiedTaskId){
      let $temp = $("<textarea></textarea>");
      $('body').append($temp);
      $temp.val(str);
      $temp.text($(this).next().text()).select();
      document.execCommand("copy");
      $temp.remove();
      this.copiedTaskId = copiedTaskId?copiedTaskId:-1;
      setTimeout(()=>{this.copiedTaskId=-1},2000);
    },

    // copyTaskNumberToClipboard(input_id){
    //     let $temp = $("<textarea></textarea>");
    //     $('body').append($temp);
    //     $temp.val('#'+input_id.slice(4));
    //     $temp.text($(this).next().text()).select();
    //     document.execCommand("copy");
    //     $temp.remove();
      // let input = document.querySelector(`#${input_id}`);
      // input.value="12321";
      // input.select();
      // document.execCommand('copy');
    // },



    getTaskTotalTime(times) {
      let korsy = "00:00:00";
      korsy = moment.duration("00:00:00");
      times.forEach(item => {
        korsy = moment.duration(korsy).add(moment.duration(item.time));
      });
      //  let time = korsy.humanize();
      // return korsy;
      // this.allTasksTotalTime = moment.duration(this.allTasksTotalTime).add(moment.duration(korsy))
      return moment.utc(korsy.as("milliseconds")).format("HH:mm:ss");
    },
    setAllTasksTotalTimeFormat() {
      let korsy = "00:00:00";

      this.tasks.forEach(task => {
        task.task_time_duration.forEach(item => {
          korsy = moment.duration(korsy).add(moment.duration(item.time));
        });
      });
      this.allTasksTotalTime = moment
        .duration(this.allTasksTotalTime)
        .add(moment.duration(korsy));

      // let korsy = "00:00:00";
      // this.tasks.forEach(item => {
      //   korsy = moment.duration(korsy).add(moment.duration(item.time));
      // });
    },
    getAllTasksTotalTimeFormat() {
      return moment
        .utc(moment.duration(this.allTasksTotalTime).as("milliseconds"))
        .format("HH:mm:ss");
    },
    SplitTime(numberOfHours) {
      let sptString = numberOfHours.toFixed(2).toString();
      let minutes = sptString.substr(sptString.indexOf(".") + 1);
      let hours = sptString.slice(0, sptString.lastIndexOf("."));
      let timeHumanize = moment.duration({
        minutes: minutes,
        hours: hours
      });
      hours = parseInt(hours);
      if (minutes > 59) {
        hours += 1;
        minutes = 0;
      }

      let timetoWiew = hours + "h" + minutes + "m";
      if (hours == 0 && minutes == 0) {
        return " ";
      } else {
        return timetoWiew;
      }
    },

    SplitEstTime(numberOfHours) {
      let sptString = numberOfHours.toFixed(2).toString();
      let minutes = sptString.substr(sptString.indexOf(".") + 1);
      let hours = sptString.slice(0, sptString.lastIndexOf("."));
      let timeHumanize = moment.duration({
        minutes: minutes,
        hours: hours
      });
      hours = parseInt(hours);
      if (minutes > 59) {
        hours += 1;
        minutes = 0;
      }

      let timetoWiew = hours + "h" + minutes + "m";
      if (hours == 0 && minutes == 0) {
        return " ";
      } else {
        return timeHumanize.humanize();
      }
      // return timeHumanize.humanize()
      // return timetoWiew;
    },

    getTotslSpt() {
      let queryParams = this.getQueryParams();
      apiClientCreator(`tasks/total_spt`)
        .get("", { params: queryParams })
        .then(res => {
          this.totalSpt = this.hoursFormatter(res.data);
          // this.SplitTime(res.data).length > 0 ? this.SplitTime(res.data) : 0;
        });
      /*        .catch(err => {
                  });*/
    },
    getTotalEst() {
      let queryParams = this.getQueryParams();
      apiClientCreator(`tasks/total_est`)
        .get("", { params: queryParams })
        .then(res => {
          this.totalEst =
            this.SplitEstTime(res.data).length > 0
              ? this.SplitEstTime(res.data)
              : 0;
          // this.totalEst = res.data;
        });
      /*        .catch(err => {
                  });*/
    },
    // updateTitle(val) {
    //   if (val.length !== 0) {
    //     this.newTask.cat_arr = val;
    //   } else if (val.length === 0) {
    //     this.newTask.cat_arr = [];
    //   }
    // },
    getIdForView(task) {
      // if (this.getOriginalCreator(task) == this.auth.user.id) {
      //   return task.id;
      // } else {
      //   return task.sub_task_assignment.length > 0 ? task.id + "/1" : task.id;
      // }
      // return `${task.id}/${task.sub_task_pos_id}`;
      // return `${task.main_task_id}/${task.sub_task_pos_id}`;

      if (task.main_id !== null) {
        return task.main_id;
        // return `${task.id}/${task.sub_task_pos_id}`;
      } else {
        return `${task.real_task_main_id.main_id}/${task.sub_task_pos_id}`;
        // return `${task.main_task_id}/${task.sub_task_pos_id}`;
      }
    },
    getOriginalCreator(task) {
      let originalCreator = null;
      task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });

      return originalCreator;
    },
    applyAmountSortingMod() {
      // reverse sortOrder
      if (!this.filters.sort_for_mod) {
        this.filters.sort_for_mod = "DESC";
        return;
      }

      if (this.filters.sort_for_mod === "ASC") {
        this.filters.sort_for_mod = "DESC";
        return;
      }
      if (this.filters.sort_for_mod === "DESC") {
        this.filters.sort_for_mod = "ASC";
        return;
      }
    },
    applyAmountSortingCreated() {
      // reverse sortOrder
      if (!this.filters.sort_for_created) {
        this.filters.sort_for_created = "DESC";
        return;
      }

      if (this.filters.sort_for_created === "ASC") {
        this.filters.sort_for_created = "DESC";
        return;
      }
      if (this.filters.sort_for_created === "DESC") {
        this.filters.sort_for_created = "ASC";
        return;
      }
    },
    applyAmountSortingSpt() {
      // reverse sortOrder
      if (!this.filters.sort_for_spt) {
        this.filters.sort_for_spt = "DESC";
        return;
      }

      if (this.filters.sort_for_spt === "ASC") {
        this.filters.sort_for_spt = "DESC";
        return;
      }
      if (this.filters.sort_for_spt === "DESC") {
        this.filters.sort_for_spt = "ASC";
        return;
      }
    },
    applyAmountSortingTimeRunning() {
      // reverse sortOrder
      if (!this.filters.sort_for_time_running) {
        this.filters.sort_for_time_running = true;
        return;
      }

      if (this.filters.sort_for_time_running === false) {
        this.filters.sort_for_time_running = true;
        return;
      }
      if (this.filters.sort_for_time_running === true) {
        this.filters.sort_for_time_running = false;
        return;
      }
    },
    applyAmountSortingTaskOnWork(flag) {
      this.filters.sort_for_task_on_work = flag;
      return;
      // if (!this.filters.sort_for_time_running) {
      //   this.filters.sort_for_time_running = true;
      //   return;
      // }
      //
      // if (this.filters.sort_for_time_running === false) {
      //   this.filters.sort_for_time_running = true;
      //   return;
      // }
      // if (this.filters.sort_for_time_running === true) {
      //   this.filters.sort_for_time_running = false;
      //   return;
      // }
    },
    applyAmountSorting() {
      // reverse sortOrder
      if (!this.filters.sort_for_id) {
        this.filters.sort_for_id = "DESC";
        return;
      }

      if (this.filters.sort_for_id === "ASC") {
        this.filters.sort_for_id = "DESC";
        return;
      }
      if (this.filters.sort_for_id === "DESC") {
        this.filters.sort_for_id = "ASC";
        return;
      }
    },
    countClose() {
      this.closeRec += 1;
    },
    giveReadOnlyTaskBackgroundGrey(task) {
      return task.task_read_only.some(
        user => user.user_id === this.auth.user.id
      );
    },
    filterTagTitle(val) {
      this.filters.tag_id = val;
      // if (val) {
      //   this.temp = val;
      // }
      // this.filters.tag_title = val;
      // if (val.length === 0) {
      //   this.filters.tag_title = null;
      // }
    },
    filterTagId(val) {
      this.filters.tag_id = val;
    },
    changeToWaitingTabAfterCreatingATask() {
      this.selectedTab = "waiting";
    },
    selectAll() {
      if (!this.bulkCheckBoxChecked) {
        this.allSelectedInPage = true;
        let client;
        for (client in this.tasks) {
          this.selectedTasks.push(this.clients[client].id.toString());
        }
      }
      if (this.bulkCheckBoxChecked) {
        let selected = this.selectedTasks;
        this.tasks.forEach(task => {
          selected = selected.filter(item => item !== task.id.toString());
        });
        this.selectedTasks = selected;
      }
      this.selectAllTasks = false;
    },

    checkOwnership(task) {
      let arr = [];
      for (let i = 0; i < task.task_assignment.length; i++) {
        arr.push(task.task_assignment[i].assigned_by.id);
      }
      let creators = [...new Set(arr)];

      return creators.includes(this.auth.user.id);
    },

    hasWaiting(task) {
      const waiting = task.reply.some(el => el.status_id === 6);
      if (waiting) {
        return true;
      }
      return false;
    },
    saveTaskAndContinue() {
      localStorage.setItem("crm-saved-task-text", this.newTask.taskText);
      localStorage.setItem(
        "crm-saved-task-type",
        JSON.stringify(this.newTask.taskType)
      );
      this.newTask.showNewTaskOptionsEditor = true;

      this.newTask.showNewTaskUsersEditor = true;
    },
    checkSavedTaskInStorage() {
      const savedTaskText = localStorage.getItem("crm-saved-task-text");
      const savedTaskType = localStorage.getItem("crm-saved-task-type");
      if (savedTaskText !== null) {
        this.newTask.taskText = savedTaskText;
        this.newTask.taskType = JSON.parse(savedTaskType);
      }
    },
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },

    clearReplySets() {
      this.showReplyAssignInp = null;
      this.showReplyStatusInp = null;
      // this.selectedTab = "waiting";
    },
    handleReplyPrepare(task) {

      this.showReplyAssignInp = task.id;
      this.showReplyStatusInp = task.id;
      let ids = [];
      this.assignReplyTo = [];
      let assignList = task.task_assignment;
      if (this.checkPermissions(this.auth, [6, 7])) {
        //   usersList = usersList.filter(user=>user.team_id === this.auth.user.team_id)
        assignList = task.task_assignment.filter(
          assign => assign.assigned_to.team_id === this.auth.user.team_id
        );
      }
      assignList.forEach(item => {
        ids.push(item.id);
        this.assignReplyTo = [
          ...this.assignReplyTo,
          this.salesPersonList.filter(
            person => person.id === item.assigned_to.id
          )[0]
        ];
      });;
      this.startAssignReplyTo = this.assignReplyTo;
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    taskStatusOutClose() {
      if (this.openTaskStatusMenu === true) {
        this.debouncedTasksQuery();
        this.viewHideResetBtn();
        this.openTaskStatusMenu = false;
      }
    },
    statusFilterMenuHandler() {
      if (this.openTaskStatusMenu) {
        return (this.openTaskStatusMenu = false);
      }
      if (!this.openTaskStatusMenu && this.filters.task_sub_statuses) {
        return (this.openTaskStatusMenu = true);
      }
      if (this.openTaskStatusMenu && this.filters.task_sub_statuses) {
        return (this.openTaskStatusMenu = false);
      }
      this.openTaskStatusMenu = true;
    },

    todayTasksFilterMenuHandler() {
      if (this.openTaskStatusMenu) {
        return (this.openTaskStatusMenu = false);
      }
      if (!this.openTaskStatusMenu && this.filters.missed_tasks) {
        return (this.openTaskStatusMenu = true);
      }
      if (this.openTaskStatusMenu && this.filters.missed_tasks) {
        return (this.openTaskStatusMenu = false);
      }
      this.openTaskStatusMenu = true;
    },

    missedTasksFilterMenuHandler() {
      if (this.openTaskStatusMenu) {
        return (this.openTaskStatusMenu = false);
      }
      if (!this.openTaskStatusMenu && this.filters.missed_tasks) {
        return (this.openTaskStatusMenu = true);
      }
      if (this.openTaskStatusMenu && this.filters.missed_tasks) {
        return (this.openTaskStatusMenu = false);
      }
      this.openTaskStatusMenu = true;
    },
    comingTasksFilterMenuHandler() {
      if (this.openTaskStatusMenu) {
        return (this.openTaskStatusMenu = false);
      }
      if (!this.openTaskStatusMenu && this.filters.coming_tasks) {
        return (this.openTaskStatusMenu = true);
      }
      if (this.openTaskStatusMenu && this.filters.coming_tasks) {
        return (this.openTaskStatusMenu = false);
      }
      this.openTaskStatusMenu = true;
    },

    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm");
    },
    setPage(pageNum) {
      this.pagination.currentPage = pageNum;
      this.fetchTasks();
      this.pageNumInput = "";
    },
    debouncedTasksQuery: _.debounce(function() {
      this.pagination.currentPage = 1;

      this.fetchTasks();
    }, 700),

    getQueryParams() {
      let vm = this;

      let queryParams = {
        page: vm.pagination.currentPage
        // order_by: vm.orderBy,
        // sort_order: vm.sortOrder
      };

      /** Add filters to query */
      for (let key in vm.filters) {
        if (!vm.filters.hasOwnProperty(key)) {
          continue;
        }

        if (vm.filters[key] === null || vm.filters[key] === false) {
          continue;
        }

        if (key === "order_by" || key === "sort_order") {
          queryParams[key] = vm.filters[key];
        }
        if (key === "task_id") {
          queryParams[key] = vm.filters[key];
        }
        if (key === "tag_id") {
          queryParams[key] = vm.filters[key];
        }
        if (key === "tag_title" && vm.filters[key] !== "") {
          queryParams[key] = vm.filters[key];
        }

        if (
          (key === "email" || key === "loc_phys_ms" || key === "placement") &&
          vm.filters[key].toString().length > 2
        ) {
          queryParams[key] = vm.filters[key];
        }

        if (
          key === "task_types" ||
          key === "task_statuses" ||
          key === "task_sub_statuses" ||
          key === "task_priorities" ||
          key === "task_invite_users" ||
          key === "task_users"
        ) {
          let ids = [];

          vm.filters[key].forEach(function(item) {
            ids.push(item.id);
          });

          queryParams[key] = ids;
        }

        if (key === "sort_for_id" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }

        if (key === "sort_for_mod" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }
        if (key === "sort_for_created" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }
        if (key === "sort_for_spt" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }
        if (key === "sort_for_time_running" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }
        if (key === "sort_for_task_on_work" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }
        if (key === "key_word" && vm.filters[key]) {
          queryParams[key] = vm.filters[key];
        }

        if (
          key === "active_group" ||
          key === "waiting_group" ||
          key === "completed_group" ||
          key === "events_group" ||
          key === "shift_group" ||
          key === "canceled_group" ||
          key === "progress_group" ||
          key === "waiting_approval_group" ||
          key === "show_all_tasks" ||
          key === "outline_group"
        ) {
          queryParams[key] = 1;

          const filterToPush = this.filtersBarArr;
          const filtered = filterToPush.filter(item => item.key !== key);
          const filter_ = {
            text: key,
            stat: "",
            key: key
          };
          this.filtersBarArr = [...filtered, filter_];
        }

        if (key === "countryTime") {
          queryParams["country_time_from"] = vm.filters.countryTime.from;
          queryParams["country_time_to"] = vm.filters.countryTime.to;
        }

        if (
          key === "status_assigned_at" &&
          vm.filters.status_assigned_at.length > 0
        ) {
          queryParams["status_assigned_from"] =
            vm.filters.status_assigned_at[0];
          queryParams["status_assigned_to"] = vm.filters.status_assigned_at[1];
        }
      }
      this.$store.commit("tasks/setQueryForCharts", queryParams);
      return queryParams;
    },
    kFormatter: function(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    resetTaskTypeSelector() {
      this.filters.task_types = [];
      this.viewHideResetBtn();
    },
    resetPrioritySelector() {
      this.filters.task_priorities = [];
    },
    resetTaskStatusesSelector() {
      this.filters.task_sub_statuses = [];
    },
    resetTaskSubStatusesSelector() {
      this.filters.task_sub_statuses = [];
    },
    resetInviteUsersSelector() {
      this.filters.task_users = [];
    },
    resetUsersSelector() {
      this.filters.task_invite_users = [];
    },
    // resetTagId() {
    //   this.filters.tag_id = [];
    // },
    resetThFields() {
      this.resetMultiSelects = true;
      this.filters.task_sub_statuses = [];
      this.filters.task_priorities = [];
      this.filters.task_types = [];
      this.filters.task_invite_users = [];
      this.filters.task_users = [];
      this.filters.task_id = null;
      this.filters.tag_id = [];
      this.filters.tag_title = null;
      this.filters.status_assigned_at = [];
      this.filters.sort_for_id = null;
      this.filters.sort_for_mod = null;
      this.filters.sort_for_created = null;
      this.filters.sort_for_spt = null;
      this.filters.sort_for_time_running = null;
      this.filters.sort_for_task_on_work = null;
      this.filters.key_word = null;
      this.wordFilter = "";
      this.resetClicked = true;

      this.$store.commit("tasks/setResetQuery", true);
      //this.$store.commit("tasks/setResetTags", true);
    },
    viewHideResetBtn() {
      this.resetMsAfterFilter = true;
      if (
        this.filters.task_sub_statuses.length > 0 ||
        this.filters.task_priorities.length > 0 ||
        this.filters.task_types.length > 0 ||
        this.filters.task_invite_users.length > 0 ||
        this.filters.task_users.length > 0 ||
        this.filters.status_assigned_at.length > 0 ||
        this.filters.tag_id.length > 0 ||
        this.filters.tag_title !== null ||
        this.filters.task_id !== null ||
        this.filters.sort_for_id !== null ||
        this.filters.sort_for_mod !== null ||
        this.filters.sort_for_created !== null ||
        this.filters.sort_for_spt !== null ||
        this.filters.sort_for_time_running !== null ||
        this.filters.sort_for_task_on_work !== null ||
        this.filters.key_word !== null
      ) {
        return (this.viewResetBtn = true);
      }
      return (this.viewResetBtn = false);
    },

    async toggleMainTaskWindow() {
      await this.$store.dispatch("tasks/fetchAllActiveTasks");
      await this.$store.dispatch("tasks/getCategories");
      this.showMainTaskWindow = !this.showMainTaskWindow;
    },
    closeMainTaskWindow() {
      if (
        event.target.className == "v-cal-dialog-card__header" ||
        event.target.className == "v-cal-dialog__title" ||
        event.target.className == "v-cal-input" ||
        event.target.className == "v-cal-input " ||
        event.target.className == "v-cal-input-group" ||
        event.target.className == "v-cal-dialog-card__footer" ||
        event.target.className == "v-cal-dialog__close" ||
        event.target.className == "v-cal-dialog__bg" ||
        event.target.className == "v-cal-button is-rounded is-primary" ||
        event.target.className == "v-cal-dialog-card__body" ||
        event.target.className == "v-cal-fields" ||
        event.target.className == "v-cal-label" ||
        event.target.className == "form-control" ||
        event.target.className == "select-option" ||
        event.target.className == "vue__time-picker time-picker" ||
        event.target.className == "display-time all-selected" ||
        event.target.className == "dropdown" ||
        event.target.className == "clear-btn" ||
        event.target.className == "select-list" ||
        event.target.className == "hours" ||
        event.target.className == "minutes" ||
        event.target.className == "time-picker-overlay" ||
        event.target.className == "custom-select" ||
        event.target.className == "option" ||
        event.target.className == "active" ||
        event.target.className == "btn" ||
        event.target.className == "btn-md" ||
        event.target.className == "btn-approved" ||
        event.target.className == "col-sm-6" ||
        event.target.className == "btn-bar" ||
        event.target.className == "row" ||
        event.target.nodeName == "BUTTON" ||
        event.target.className == "close-img-modal" ||
        event.target.className == "modal-content" ||
        event.target.className == "modal" ||
        event.target.className == ""
      ) {
      } else {
        this.showMainTaskWindow = false;
      }
    },
    ///////////////////*API SECTION*////////////////////////

    getOutlineGroupTasksCountStats() {
      const queryParams = this.getQueryParams();
      apiClientCreator(`tasks/stats/group/outline`)
        .get("", { params: this.getQueryParams() })
        .then(res => {
          this.stats.outline_group = res.data;
        });
      apiClientCreator(`tasks/stats/group/outline/count_new`)
        .get("", { params: this.getQueryParams() })
        .then(res => {
          this.stats.new.outline_group = res.data;
        });

      /*        .catch(err => {
                  });*/
    },


    getWaitingGroupTasksCountStats() {
      apiClientCreator(`tasks/stats/group/waiting`)
        .get("", { params: this.getQueryParams() })
        .then(res => {
          this.stats.waiting_group = res.data;
        });
      /*        .catch(err => {
                     });*/
    },



    getCompletedGroupTasksCountStats() {
      apiClientCreator(`tasks/stats/group/completed`)
          .get("", { params: this.getQueryParams() })
          .then(res => {
            this.stats.completed_group = res.data;
          });
      /*        .catch(err => {
                      });*/
    },

    //TODO kobi
    getEventsGroupTasksCountStats() {
      apiClientCreator(`tasks/stats/group/events`)
          .get("", { params: this.getQueryParams() })
          .then(res => {
            this.stats.events_group = res.data;
          });
      /*        .catch(err => {
                      });*/
    },


    updateStats() {
      this.getTotalEst();
      this.getTotslSpt();
      //this.getActiveGroupTasksCountStats();
      this.$store.dispatch("tasks/fetchActiveTasksCounter");
      this.getWaitingGroupTasksCountStats();
      this.getCompletedGroupTasksCountStats();
      this.getOutlineGroupTasksCountStats();
      this.getEventsGroupTasksCountStats();
    },

    cancelAddTask() {
      this.newTask.taskText = "";
      // this.newTask.taskType = null;
      this.newTask.taskUser = [];
      this.newTask.taskGroup = [];
      this.newTask.taskPriority = {
        id: 2,
        type: "LOW",
        title: "Low Priority"
      }; // FIRES ERROR WHEN ADDING SEVERAL TASKS IN ROAD WITHOUT LOADING
      this.newTask.taskDateTime = null;
      // this.calendarButtonText = "Select date";
      this.newTask.timeQuantity = 24;
      this.newTask.selectedConnTaskId = null;
      this.newTask.cat_arr = [];
      localStorage.removeItem("crm-saved-task-text");
      localStorage.removeItem("crm-saved-task-type");
    },
    async updateTaskType(typeId, taskId) {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/update/type/${taskId}`
        );
        await addNewClientRequest.put("", { type_id: typeId });
        this.fetchTasks();
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task type updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task type update " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    async updatePriority(typeId, taskId) {
      try {
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(
          `tasks/update/priority/${taskId}`
        );
        await addNewClientRequest.put("", { priority_id: typeId });
        this.fetchTasks();
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task priority updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task priority update " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    fetchTasks(withStats) {
      // this.tasks = [];
      let apiClient = apiClientCreator("tasks/list");
      this.$store.commit("clients/setLoading", true);
      const queryParams = this.getQueryParams();
      if(this.showCards){
        queryParams.cardView = true;
      }
      const tasks = [];
      // this.tasks = [];
      apiClient
        .get("", { params: queryParams })
        .then(res => {
          res.data.data.forEach(function(data) {
            tasks.push(new TaskModel(data));
          });
          this.getQueryParamsToMs = queryParams;

          if (!withStats) {
            this.updateStats();
          }
          // this.tasks = [];
          this.cardDisplayRows = (tasks.length > 7);
          this.tasks = tasks;
          this.pagination.currentPage = res.data.current_page;
          this.pagination.perPage = res.data.per_page;
          this.pagination.from = res.data.from;
          this.pagination.to = res.data.to;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;
          this.resetCalendars = false;
          this.resetMultiSelects = false;
          this.sendUpdated = true;
          this.$store.commit("clients/setLoading", false);
          // this.setAllTasksTotalTimeFormat();

          return res;
        })
        .catch(e => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Connection Error!" + " " + " Error Status: " + e.response.status,
            type: "ERROR",
            op: { type: "SYSTEM" }
          });

          this.$store.commit("clients/setLoading", false);
        });
    },

    filterFunction(userInput) {
      return this.salesPersonList.filter(function(broker) {
        userInput = userInput.trim();
        userInput = userInput.toLowerCase();
        let afterRegex = userInput.replace(/[.*+\-?^${}()|[\]\\]/g, "");
        return broker.full_name.toLowerCase().includes(afterRegex);
      });
    },
    tagsFillter(tagId) {
      // this.filters.tag_id = [tagId];
      this.filters.tag_id.push(tagId);
    },
    // updateTitle(val) {
    //   if (val.length !== 0) {
    //     this.newTask.cat_arr = val; // TODO: parse string to object
    //   }
    // }
    getSrc(data, sources = false){
      //START get clean images and iframes src
      let splitedString = data.split("<");

      let files = splitedString
          .filter(i => i.startsWith("img"))

      //return default image if no images in tasks
      if(!files.length && !sources){
        return '';
      }
      //some shit line what return clean src
      if(!sources){
        return files[0].split('src="')[1].split('" class="')[0].split('">')[0];
      }
      if(sources){
        let smallSources = [];
        files = files.map((file, idx) => {
          if(idx < 1) return;
          file = file.split('src="')[1].split('" class="')[0].split('">')[0];
          smallSources.push(file);
        })
        return smallSources;
      }
    },
    ///////////////////*END API SECTION*////////////////////////
  },

  beforeDestroy() {
    this.$root.$off("task_check_timer_stop");
    this.$store.dispatch("tasks/fetchActiveTasks");
    // this.$store.commit("tasks/setPreOpenMainTaskWindowFromHeader", false);
  }
};
</script>

<style lang="scss" scoped>
.image-show-row td:empty, .image-show-row-1 td:empty,{
  display: none;
}

.image-show-one-row td:empty{
  display: none;
}

.image-show-row td, .image-show-row-1 td{
  padding: 3px;
}

.image-show-row-1{
  position: absolute;
  top: 45.5rem;
}

#show-img-view{
  top: -6px;
  position: relative;
}



.image-show-row{
  position: absolute;
}

.image-show-one-row{
  position: absolute;
  display: flex;
  width: 100%;
  flex-direction: row;
  height: 31rem;
}
.show-image-all{
  display: flex;
  align-items: center;
  padding-top: .6rem;
  position: relative;
  top: 4px;
}
.show-image-all label{
  white-space: nowrap;
  font-weight: bold;
  margin-right: 4px;
  font-size: 1.2rem;
}
.images-sort{
  display: flex;
  border-bottom: none;
  justify-content: space-between;
  min-width: 10rem;
}

.images-td div{
  position: relative;
  left:10px;
}
.root-layout {
  height: 455px;
  width: 100%;
  background-color: white;
  /* overflow: auto;*/
  white-space: nowrap;
  position: absolute;
}
.paginationContainer {
  margin-top: 10px;
  /*margin-left: 10px;*/
  margin-right: 5px;
  width: 180px;

  button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-font-smoothing: subpixel-antialiased;
    font-kerning: normal;
    box-sizing: border-box;
    margin: 0;
    font: inherit;
    overflow: visible;
    text-transform: none;
    -webkit-appearance: button;
    font-family: inherit;
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    user-select: none;
    font-size: 12px;
    box-shadow: none !important;
    line-height: 18px;
    font-weight: 400;
    color: #555555 !important;
    cursor: pointer;
    border-radius: 0 !important;
    position: relative;
    float: left;
    opacity: 0.4;
    margin-left: 0;
    border-top-left-radius: 2px !important;
    border-bottom-left-radius: 2px !important;
    margin-right: 0 !important;
    background: none !important;
    border: none !important;
    padding: 0 4px !important;
    background-color: Transparent !important;
  }
}
::placeholder {
  color: #b9b9b9;
  opacity: 1; /* Firefox */
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #b9b9b9;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #b9b9b9;
}
.nav-tabs {
  font-family: "Montserrat" !important;
  margin-bottom: 0;

  a {
    color: black;
    font-size: 12px;
    transition: background 0.2s ease, color 0.2s ease;
    margin: 0;
  }
  a:hover {
    color: white;
    background-color: #44a2d2;
  }
  li.active {
    border-top-color: transparent !important;
    font-size: 12px;
    color: #44a2d2;

    a {
      color: white;
      background-color: #44a2d2;
    }

    a:hover {
      background-color: #44a2d2;
    }

    li.active:hover {
      /*  border-bottom: 2px solid #44a2d2 !important;*/
      background: #44a2d2;
      color: white;
    }
  }

  li:hover {
    border-top-color: transparent !important;
    /*
        background: #e0e0e0;
    */
  }
  .non-nav:hover {
    background: transparent;
  }
}
.btn-trash {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-font-smoothing: subpixel-antialiased;
  margin-right: -5px;
  margin-left: 7px;
  margin-top: 1px;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  font-size: 17px;
  cursor: pointer;
  float: left;
  border: none !important;
  background-color: Transparent !important;
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
}
.name-input-group {
  display: flex;
  margin-left: -4px;
  padding-right: 0;
}
.listview-pagenum {
  text-align: center;
  white-space: nowrap;
  padding: 3px 10px;
  margin-bottom: 6px;
  font-size: 13px;
}
.listViewPagingInput {
  width: 70px;
  padding: 0 5px;
  margin-top: 5px;
  vertical-align: middle;
}
#pageToJumpSubmit {
  margin-left: 15px;
  margin-top: 5px;
  border-radius: 2px;
  line-height: 11px;
  cursor: pointer;
  font-weight: 800;
  padding: 6px 16px !important;
  color: #448aff !important;
  border: thin solid #448aff !important;
  background-color: #ffffff !important;
  background: none;
  font-size: 12px;
  height: 24px;
  font-family: "SegoePro-Regular", Arial, sans-serif;
}

.fa-chevron-right-black {
  color: black;
  font-weight: 800;
}
.fa-chevron-left-black {
  color: black;
  font-weight: 800;
}
.main-table {
  margin-bottom: 0px;
}
.main-table > tbody > tr::selection,
.selected-client {
  background-color: #cfd8dc;
}
.main-table td {
  border-color: #cfd8dc;
}
.tr-hover-override :hover {
  /*background-color: #eceff1;*/
}
.tr-info {
  border-color: #cfd8dc;
  border-style: solid;
  border-top-width: thin;
  border-left-width: thin;
  border-right-width: thin;
}
th.th-id {
  width: 1%;
  text-align: center;
}
th.th-checkbox {
  width: 1%;
  text-align: center;
}

th.th-type {
  width: 4%;
  /*width: 5%;*/
  text-align: center;
}
th.th-date-mod {
  width: 7%;
  text-align: center;
}
th.th-date-created {
  width: 7%;
  text-align: center;
}
th.th-created-by {
  width: 7%;
  text-align: center;
}
th.th-task-content {
  width: 63%;
  /*width: 35%;*/
  text-align: center;
  padding-left: 0px;
}
th.th-priority {
  width: 3%;
  text-align: center;
}
th.th-timer {
  position: relative;
  padding: 0px;
  width: 3%;
  text-align: center;
}
th.th-type-small {
  width: 6%;
  /*width: 4%;*/
  text-align: center;
}
th.th-invite {
  width: 7%;
  text-align: center;
}
th.th-invite-date {
  width: 7%;
  text-align: center;
}
th.th-log {
  width: 2%;
  text-align: center;
}
.input-standard {
  width: 70px;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}
.input-id {
  width: 99%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}
.input-timer {
  width: 100%;
  padding: 2px;
  border-radius: 3px;
  border-style: solid;
  border-color: #90a4ae;
  height: 23px;
  border-width: thin;
  overflow: hidden;

  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.selected-client-hover {
  background-color: #eceff1;
}
.tab-count {
  color: #1e88e5;
}
.new-client-cancel-btn {
  color: red !important;

  margin-right: 5px;
  margin-top: 5px;
}

.new-client-ok-btn {
  color: green !important;

  margin-right: 20px;
  margin-top: 5px;
}
.floating-wrapper {
  position: relative;
}
.td-center {
  text-align: center;
}
.td-center-content {
  text-align: center;
  padding-top: 1px;
  padding-bottom: 2px;
}
.floating-wrapper {
  position: relative;
}
.floating-wrapper-disabled {
  pointer-events: none;
  cursor: not-allowed;
}
.assignment-dropdown-menu {
  position: absolute;
  left: -5px;
  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.assignment-dropdown-menu ul {
  list-style: none;
  padding-left: 0;
}

.assignment-dropdown-menu li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
  cursor: pointer;
}

.assignment-dropdown-menu li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.assignment-dropdown-menu .item-text {
  vertical-align: middle;
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
}
.assignment-dropdown-menu .item-checkbox {
  vertical-align: middle;
  margin-bottom: 4px;
  margin-right: 5px;
}

.bulk-duplicate-assignment-dropdown-menu {
  position: absolute;
  top: 10px;
  left: 0px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;

  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.add-tag-menu-item-title {
  margin: 5px;
  font-size: 10pt;
  font-weight: bold;
  cursor: pointer;
  color: #808080;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.cancel-edit-menu-item {
  color: #f44336;
  font-weight: bold;
}
.dropdown-menu {
  padding: 5px;
  height: auto;
  /*width: 100px !important;*/
  max-height: 200px;
  overflow-x: hidden;
}
.assign-menu-item {
  /*display: none;*/
  margin: 5px;
  font-size: 9pt;
  font-family: "SegoePro-Regular", Arial, sans-serif;
}
.open {
  display: block;
}
.close {
  display: none;
}
.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.btn-trash {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-font-smoothing: subpixel-antialiased;
  margin-right: -5px;
  margin-left: 7px;
  margin-top: 1px;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  font-size: 17px;
  cursor: pointer;
  float: left;
  background: none !important;
  border: none !important;
  background-color: Transparent !important;
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
}
.mng-btn-bar-left {
  width: 45px;
}
.date-picker {
  /*position: absolute;*/
  /*right: 190px;*/
}
.mx-input-append {
  display: none !important;
}

.add-task-first-element {
}

.selector-btn {
  border: none;
  background: none;
  padding: 2px;
  border-radius: 3px;
}
.selector-btn:hover {
  background: #9e9e9e;
}
.tag-form-btns {
  position: absolute;
  /*right: 120px;*/
  left: 400px;
  display: flex;
  width: 60px;
}
.pointer {
  cursor: pointer;
}
.input-main {
  width: 117px;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 117px;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
        margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /*padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
}
.timer-icon {
  max-width: 28px !important;
}

.selector-btn {
  border: none;
  background: none;
  border-radius: 3px;
  cursor: pointer;
}
.selector-btn:hover {
  background: #9e9e9e;
}
.btn-jump-25 {
  /*position: absolute;*/
  /*right: 190px;*/
  left: 348px;
  font-size: 9pt;
  padding: 4px;
}
.btn-add-task {
  font-size: 9pt;
  padding: 4px;
  margin-left: 5px;
}

.add-task-text-popup {
  position: relative;
  top: -329px;
  right: -270px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  width: 1175px;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  height: 525px;
}
.options {
  display: flex;
}
.stay-open {
  display: block !important;
  max-height: 500px;
  top: -13px;
  position: absolute;
  left: -145px;
  box-shadow: none;
  width: 277px;
}
.popup-wrapper {
  display: inline-block;
}
.add-task-options-popup {
  left: 336px;
  position: absolute;
  top: 592px;
  /* right: -220px; */
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 36%;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.add-task-options-user {
  position: relative;
  left: 479px;
  height: 412px;
  top: -358px;
}

.edit-text-cancel-btn {
  color: red !important;
  position: absolute;
  right: 10px;
  bottom: 5px;
}
.edit-text-ok-btn {
  color: green !important;
  position: absolute;
  right: 25px;
  bottom: 5px;
}
.w100 {
  width: 100%;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  background-color: white;
  min-height: 400px;
}
.cartoon {
  position: absolute;
  height: 205px;
  left: 730px;
}
.cartoon img {
  height: 205px;
}
.bttn-add-task {
  font-family: Montserrat !important;
  width: fit-content;
  margin-top: 1.5rem;
  margin-bottom: -10px;
  margin-left: 1rem;
  background: #44a2d2;
  color: white;
  border: 0;
  padding: 5px;
  font-size: 11px;
  cursor: pointer;
}

.btn-reply-box {
  /*    padding: 3px;
        height: 20px;
        line-height: 10px;
        font-size: 8pt;
        margin-left: 5px;*/

  margin-top: 3px;
  margin-bottom: 3px;
  white-space: nowrap;
  cursor: pointer;
  vertical-align: middle;
  padding: 2px;
  text-align: center;
  background: #fafafa;
  line-height: 1;
  font-size: 10pt;
  border: 1px solid transparent;
  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;
  -webkit-appearance: none;
}

.btn-reply-box:hover {
  background: #44a2d2;
  color: white;
}
.btn-reply-box-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 2px;
  /* position: absolute;
         right: 10px;
         bottom: 5px;*/
}
.div-btn-reply-box {
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid #c4c4c4;
  padding-left: 3px;
  background: #fafafa;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  text-align: left;
  position: absolute;
  top: 478px;
  left: 323px;
  width: 836px;
}
.toolbar-separator {
  border-left: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  margin-top: 0;
  margin-right: 2px;
  margin-left: 2px;
}
.conn-task-panel {
  height: auto;
  overflow-x: hidden;
  max-height: 150px;
  font-size: 8pt;
}
.conn-task-panel tr:hover {
  background-color: #c4c4c4;
  cursor: pointer;
}
.selected-my-task {
  margin-top: 3px;
  margin-bottom: 3px;
  white-space: nowrap;
  vertical-align: middle;
  padding: 2px;
  text-align: center;
  background: #fafafa;
  line-height: 1;
  font-size: 10pt;
  border: 1px solid transparent;
  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;
  -webkit-appearance: none;
}
.button-add {
  border: 2px solid black;
  background-color: white;
  color: black;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
}

.info {
  border-color: #44a2d2;
  color: dodgerblue;
}
.info:hover {
  background: #44a2d2;
  color: white;
}
.mx-input-append {
  right: 15px;
}
.add-btn-container {
  position: absolute;
  display: inline;
  top: 295px;
}
.select-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 50%;
  text-overflow: ellipsis;
  font-weight: bold;
  font-size: 8pt;
  box-sizing: border-box;
}
.opt-standard {
  font-weight: bold;
}
.new-task-first-element {
  position: relative;
  width: -moz-max-content;
  width: -webkit-max-content;
  width: max-content;
  /* overflow-x: hidden; */
  left: -389px;
  top: -665px;
  background-color: white;
  -webkit-box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  /*border: 0.7px solid #b3b3b3;*/
  z-index: 1001;
}
.client-op-dropdown {
  position: absolute;

  /*z-index: 10001;*/
  padding: 5px;
  list-style: none;
  background-color: white;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  display: block !important;
  width: 100%;
}
.dropdown-category {
  top: 666px;
  left: 12px;
  z-index: 20002;
  width: 95%;
}
.dropdown-sub-category {
  top: 117px;
  left: 80px;
}
.assign-menu-item {
  margin: 5px;
  font-size: 9pt;
  /*
    font-family: "SegoePro-Regular", Arial, sans-serif;
  */
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.bttn[data-v-52899fd5] {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  height: 28px;
}

button.bttn.blue {
  width: max-content;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  height: 28px;
}
.add-tag-menu-item-title:hover {
  background-color: #9e9e9e;
}
.mx-input-append {
  /* display: none; */
  position: absolute;
  top: 0;
  right: 0;
  width: 70px !important;
  height: 100%;
  padding: 6px;
}
.row.add-task-first-element-category {
  margin-top: 10px;
}

row.add-task-first-element-sub-category-external {
  /*margin-top: 30px;*/
  padding-left: 29px;
}
.row.add-task-first-element-sub-category-external {
  height: 144px;
}
.row.add-task-first-element-btn {
  float: right;
}
input.d-picker {
  margin-right: 10px;
}
.mx-calendar-icon {
  display: none !important;
}
.row.add-task-first-element-btn[data-v-7f7fd3be] {
  position: absolute;
  /* float: right; */
  top: 156px;
  right: 24px;
}
.add-task-card {
  width: 1017px;
  background-color: white;
  border: 1px solid #b3b3b3;
  border-radius: 5px;
  position: absolute;
  top: 44px;
  left: -161px;
}
.add-card-body {
  padding: 10px;
  /*height: 231px;*/
  width: 100%;
}

.add-task-btn {
  border-radius: 0px;
}
#categoryInput {
  width: 100%;
  border-radius: 0px;
  margin-top: -7px;
}
.type-task-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.quillWrapper {
  position: absolute;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: auto;
  /*top: 9px;*/
  left: 320px;
  background-color: white;
  margin-right: 10px;
  height: 400px;
}
.task-user-dropdown {
  position: absolute;
  left: 166px;
  top: 22px;
}
/*.ql-editor {*/
/*  height: 200px;*/
/*  font-size: 16px;*/
/*  overflow: scroll !important;*/
/*  max-height: 238px !important;*/
/*}*/
/*#editor {*/
/*  height: 350px;*/
/*}*/

/*.ql-editor.ql-blank {*/
/*  height: 200px;*/
/*  font-size: 16px;*/
/*  overflow: scroll !important;*/
/*  max-height: 238px !important;*/
/*}*/
/*#app #editor .ql-editor {*/
/*  height: 200px;*/
/*  font-size: 16px;*/
/*  overflow: scroll !important;*/
/*  max-height: 238px !important;*/
/*}*/
.bgForPopup {
  position: absolute;
  height: 300px;
}

.img-editor {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2222222222222222222222222222222; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}
.add-task-calendar {
  background-color: white;
  z-index: 100000;
  position: absolute;
  border: 2px solid lightslategray;
  top: -260px;
  left: 0px;
}

.btn-date-picker {
  width: 100%;
}
button.close-v-calendar {
  position: absolute;
  right: -8px;
  top: -8px;
  border-radius: 5px;
  height: 30px;
  background: none;
  border: none;
}
span#taskTitle {
  padding-left: 13px;
}
hr.separator {
  margin-top: 5px;
  margin-bottom: 5px;
}
.btn-group.special {
  display: flex;
}

.special .btn {
  flex: 1;
}

.btn-group.special button:nth-child(2) {
  background: #277fca;
}
.btn-group.special button:nth-child(2):hover {
  opacity: 0.8;
}

.btn-group.special button:nth-child(3) {
  background: #649fd2;
}

.btn-group.special button:nth-child(3):hover {
  opacity: 0.8;
}
.btn-group.special button:nth-child(4) {
  background: rgb(40, 127, 152);
}

.btn-group.special button:nth-child(4):hover {
  opacity: 0.8;
}
.btn-group.special button:nth-child(5) {
  background: rgb(31, 167, 206);
}

.btn-group.special button:nth-child(5):hover {
  opacity: 0.8;
}
.btn-group.special button:nth-child(6) {
  background: rgb(4, 188, 241);
}
.btn-group.special button:nth-child(6):hover {
  opacity: 0.8;
}
.item-text {
  width: 75%;
}
#close-editor-modal {
  background: none !important;
}
.badge-info {
  background-color: #5185b3;
  padding: 4px;
}
.hasWaitingConfirmationDot {
  height: 10px;
  width: 10px;
  background-color: #ff8c68;
  border-radius: 50%;
  display: inline-block;
  margin-left: 0.3rem;
}
.checkbox-container {
  display: inline-block;
  position: relative;
  padding-left: 46px;
  margin-bottom: 12px;
  margin-left: 20px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 100;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 37px;
  width: 37px;
  background-color: #eee;
  border: 1px solid gray;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}
.transfer-to-users-box {
  position: absolute;
  right: -32px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.stay-open-transfer {
  display: block !important;
  max-height: 525px;
  top: -13px;
  position: absolute;
  left: -32px;
  width: 200px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  /*background-color: #44a2d2;*/
  background-color: #ff0000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 17px;
  top: 7px;
  width: 5px;
  height: 21px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.input-search {
  font-family: "Montserrat" !important;
  margin-left: 4px;
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.icon-conteiner {
  cursor: pointer;
}
.tagify {
  display: inline-block !important;
  width: 86% !important;
}
.back-btn {
  float: right;
  font-size: 8px;
  border-radius: 0px;
  margin-right: -6px;
}
.back-btn:active:focus {
}
.multi-check-label {
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  /*font-size: 12px;*/
  font-size: 10px;
  cursor: pointer;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}
.star {
  margin-left: 0.8rem;
}
.tags-search {
  max-width: 45%;
  flex: 2;
  /*float: left;*/
  /*padding-left: 46px;*/
}

.readOnly {
  background: #d3d3d3;
}
.noBorder {
  position: absolute;
  left: 232px;
  top: 302px;
  background: transparent;
  border: none;
}
.noBorderForAgent {
  position: absolute;
  left: 263px;
  top: 303px;
  background: transparent;
  border: none;
}
.input-after-reset {
  position: absolute;
  left: 231px !important;
  top: 303px;
  background: transparent;
  border: none;
}
.input-with-tags-inside {
  position: absolute;
  left: 277px;
  top: 303px;
  background: transparent;
  border: none;
}
.forMod {
  background: transparent;
  border: none;
  margin-left: 0;
  width: 20px;
}
.align-it {
  /*margin-left: 100px;*/
}
.table > thead > tr > th {
  vertical-align: inherit !important;
}
.mod-div {
  width: 120px;
}
.btn-for-waiting-tab {
  position: absolute;
  left: 232px;
  top: 302px;
  background: transparent;
  border: none;
}
.btn-for-agent-dif-tab {
  position: absolute;
  left: 277px;
  top: 303px;
  background: transparent;
  border: none;
}
.btn-for-dif-tab {
  position: absolute;
  left: 277px;
  top: 303px;
  background: transparent;
  border: none;
}
.sort-btn-th {
  background: none;
  border: none;
  font-size: 12px;
  width: 20px;
  height: 30px;
}

.th-id-div {
  display: flex;
  /*width: 66px;*/
  width: 52px;
}
.th-mod-div {
  display: flex;
  width: 80px;
  margin-right: auto;
  margin-left: auto;
}
.th-mod-title {
  margin-top: 5px;
}

.sort-in-btn {
  position: absolute;
  left: 197px;
  /*left: 220px;*/
}
.running-btn-on {
  color: red;
  /*border: none;*/
}
.running-btn-off {
  color: black;
  /*border: none;*/
}
.total-spt-title {
  position: relative;
  font-weight: bolder;
  font-size: 12px;
}
.task-item-td {
  /*padding: 20px ;*/
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.td-task-content {
  /*padding: 20px ;*/
  padding: 8px 0px;
}
.task-item-td-time {
  font-size: 12px;
}
.task-item-td-time-quantity {
  padding-bottom: 0px;
  padding-top: 0px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.table-running-indicator {
  position: absolute;
  height: 7px;
  width: 7px;
  background-color: grey;
  top: 35px;
  /*right: 48px;*/
  cursor: pointer;
}
.table-running-indicator-active {
  position: absolute;
  height: 7px;
  width: 7px;
  background-color: #00a700;
  top: 8px;
  /*right: 48px;*/
  cursor: pointer;
}
.counter-not-read-badge {
  position: absolute;
  top: -3px;
  /* right: -10px; */
  /* padding: 5px 10px; */
  font-weight: 600;
  background: red;
  /* color: white; */
  /* opacity: 0.7; */
  font-size: 10px;
  padding-left: 3px;
  padding-right: 5px;
  padding-top: 4px;
}
.search-input-wrapper {
  display: inline-block;
  flex: 1;
  margin-left: 10px;
  /*<!--margin-right: -96px;-->*/
  /*width: 270px;*/
}
.div-flex-wrapper {
  display: flex;
  flex-wrap: nowrap;
}
.open-btns-wrapper {
  flex: 1;
}

.copy-button{
  border-radius: 25px !important;
}
.copy-button:active{
  background-color: #cccccc;
}

</style>
